import styled from 'styled-components';

import { color } from 'theme/selectors';

export const Card = styled.div`
    max-width: 320px;
    background-color: ${color('decorative-c')};
    padding: 12px;
    border-radius: 24px;
`;
